export default __webpack_public_path__ + "static/media/pattern_hero.faa3a1da.png";